import React from 'react'
import { StyleSheet } from 'react-native';
import Modal from '@dbk/ui-modal';
import Text from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import styles from './payment-confirmation.styles';

export default ({ messages, onConfirm, onCancel, order, isModifyFlow, onDone, isMultisigFlow=false, isInitiatorFlow=false}) =>{
  //WMCE-12018 Based on the values of props(order and isModifyFlow) different popup messages are rendered for existing payment , new payment or existing modified payment
  const showCancelMessage = ()=>{
  let msg='';
   if(order){
    msg='app.payments.summary.submittedPaymentCancelMsg';
   }
   else{
    if(isModifyFlow){
      if (isMultisigFlow && !isInitiatorFlow){
        msg='app.payments.summary.modifyPaymentCancelMsgMultisig';
      } else {
        msg='app.payments.summary.modifyPaymentCancelMsg';
      }
    }
    else{
      if (isMultisigFlow){
        msg='app.payments.summary.newPaymentCancelMsgMultisig';
      } else {
        msg='app.payments.summary.newPaymentCancelMsg';
      }
    }
  }
    return (
      <div style={StyleSheet.flatten(styles.cancelContainer)}>
      <Text tabIndex={0}>
      {messages[msg]}
      </Text>
      </div>
    )
  }

  const getTitle = () => {
    if(isMultisigFlow && isInitiatorFlow) {
      return messages['app.manageContactDetails.btn.cancel'] + ' ' +messages['app.payments.multisig.cancelStatusModalTitleInitiator']  
    } else if (isMultisigFlow && !isInitiatorFlow) {
      return messages['app.manageContactDetails.btn.cancel'] + ' ' + messages['app.payments.multisig.cancelStatusModalTitleApprover']
    }
    else {
      return messages['app.payments.summary.cancelPayment']
    }
  }

  return (
  <Modal
    isActive
    hideCloseButton
    disableOutsideClick
    className="modal-payment model-window-login"
    title={getTitle()}
    onClose={()=>onCancel()}
    header={getTitle()}
    content={
      <div>  
        {showCancelMessage()}      
        <div>
        <div style={StyleSheet.flatten(styles.paymentBtnBlock)}>
            <div className="payment-btn" >
              <Button
                tertiary
                fullWidth
                onPress={onCancel} >
                {messages['app.payments.summary.cancel']}
              </Button>
            </div>
            <div className="payment-btn proceed" >
              <Button
                className="btnProceed"
                fullWidth
                onPress={()=>{onConfirm();onDone();}} >
               {messages['app.trade.label.proceed']}
              </Button>
            </div>
          </div>
        </div>
      </div> 
    }
  />
)}